import DeletedRoute from '../components/DeletedRoute/DeletedRoute';

const deletedRoutePaths = [];

const deletedRoutes = deletedRoutePaths.map((path) => ({
    path: path,
    key: path,
    component: DeletedRoute,
}));

export default deletedRoutes;
